import { render } from "./MainButtonBar.vue?vue&type=template&id=5a786b54&scoped=true"
import script from "./MainButtonBar.vue?vue&type=script&lang=js"
export * from "./MainButtonBar.vue?vue&type=script&lang=js"

import "./MainButtonBar.vue?vue&type=style&index=0&id=5a786b54&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5a786b54"

export default script